export enum DoctorSex {
  Male = "M",
  Female = "F",
}
